import { ApiClient } from '../../api/ApiClient';
import { v2 } from '../../api/ApiInterfaceV2';
import { UserLiteDataWithRole } from '../../api/endpoints/admin';
import { AppEvents, AppEventStreams } from '../AppEvents';
import { ListModel, ModelBroker } from '../dashboard/Models';
import { createScope } from '../Scope';

export class ManageUsersModel extends ListModel<UserLiteDataWithRole> {

    public readonly id = '$';

    public static create(_broker: ModelBroker) {
        return new ManageUsersModel();
    }
}

const onUserLeave = (broker: ModelBroker) => (e: AppEventStreams['account:userLeave']) => {
    broker.get(ManageUsersModel).update(x => {
        const i = x.findIndex(u => u.id === e.userId);
        if (i >= 0) x.splice(i, 1);
    });
};

const onSetRole = (broker: ModelBroker) => (e: AppEventStreams['account:setRole']) => {
    broker.get(ManageUsersModel).update(x => {
        Object.assign(x.find(u => u.id === e.userId), { roleName: e.roleName });
    });
};

// const onBoardPatch = (broker: ModelBroker) => (patch: AppEventStreams['board:patch']) =>
//     broker.get(BoardModel, patch.id)?.update(patch);

export const ManageUsersScope = createScope({
    async refresh(p, c) {
        const api = c.get(ApiClient);
        const broker = c.get(ModelBroker);
        const evts = c.get(AppEvents);

        const data = await api.exec(v2.admin.users.list('', 'roleName:asc', 0, 9999));
        const model = broker.allocate(ManageUsersModel);
        model.updateTo(data.items);
        c.bind(ManageUsersModel).toConstantValue(model);

        return [
            evts.on('account:userLeave', onUserLeave(broker)),
            evts.on('account:setRole', onSetRole(broker)),
        ];
    }
});
